import React from "react";
import { Quote } from "lucide-react";

export default function TestimonialCard({ quote, name, location, testId }) {
  return (
    <div data-testid={testId} className="glass p-10 relative rounded-sm">
      <Quote size={32} className="text-[#B5896E]/60 mb-5" />
      <p className="font-display text-xl lg:text-2xl text-[#4A3F35] leading-relaxed">
        "{quote}"
      </p>
      <div className="mt-8 pt-6 border-t border-[#B5896E]/15 flex items-center justify-between">
        <div>
          <div className="text-sm text-[#4A3F35]">{name}</div>
          <div className="caption mt-1">{location}</div>
        </div>
        <span className="w-10 h-[1px] bg-[#B5896E]" />
      </div>
    </div>
  );
}
